export default __webpack_public_path__ + "static/mechanical-bird-website-cover-4k-v3-b4d88b0c22d49acfce9592a292b0944a.svg";